var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "base-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column align-center justify-center text-center py-6",
                },
                [_c("h3", { staticClass: "mb-8" }, [_vm._v("Descarga XMLS")])]
              ),
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12", sm: "2" } }),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("v-select", {
                        ref: "cliente",
                        attrs: {
                          items: _vm.filteredClients,
                          "item-text": "text",
                          "item-value": "IdCompania",
                          label: "Selecciona una compañía",
                          "prepend-inner-icon": "mdi-sitemap",
                          required: "",
                          dense: "",
                          outlined: "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "prepend-item",
                            fn: function () {
                              return [
                                _c(
                                  "v-list-item",
                                  [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c(
                                          "v-list-item-title",
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                placeholder: "Buscar",
                                                "prepend-inner-icon":
                                                  "mdi-magnify",
                                                "hide-details": "",
                                                dense: "",
                                              },
                                              model: {
                                                value: _vm.search,
                                                callback: function ($$v) {
                                                  _vm.search = $$v
                                                },
                                                expression: "search",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.dataFilter.IdCompania,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataFilter, "IdCompania", $$v)
                          },
                          expression: "dataFilter.IdCompania",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Consecutivos (separados por coma)",
                          "prepend-inner-icon": "mdi-file-document",
                          dense: "",
                          outlined: "",
                          required: "",
                          placeholder: "Ej: FE123,FE124,FE130",
                          rows: "1",
                          "auto-grow": "",
                        },
                        model: {
                          value: _vm.dataFilter.Consecutivos,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataFilter, "Consecutivos", $$v)
                          },
                          expression: "dataFilter.Consecutivos",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { justify: "center" } },
                [
                  _c("v-col", { attrs: { cols: "12", sm: "3" } }),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "3" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-2",
                          staticStyle: {
                            "background-color": "rgb(204 33 40)",
                            color: "white !important",
                          },
                          attrs: {
                            disabled: _vm.isLoading,
                            loading: _vm.isLoading,
                            block: "",
                          },
                          on: { click: _vm.descargarXMLs },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-download"),
                          ]),
                          _vm._v(" Descargar XMLs "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-2",
                          attrs: {
                            disabled: _vm.loading && _vm.files.length === 0,
                            color: "gray",
                          },
                          on: { click: _vm.clearFields },
                        },
                        [_vm._v(" Limpiar ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "my-4", attrs: { justify: "center" } },
                [
                  _vm.isLoading
                    ? _c("v-progress-linear", {
                        staticClass: "my-4",
                        attrs: { color: "primary", indeterminate: "" },
                      })
                    : _vm._e(),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _vm.showAlert
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "my-4",
                              attrs: {
                                type: _vm.alertType,
                                dense: "",
                                outlined: "",
                                border: "left",
                                "colored-border": "",
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.alertMessage) + " ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }